import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { GroupsPlaceholder } from '@gem/components';
import { useTranslation } from '@gem/modules/i18n';
import { ICommonPopupsProps, Popup, useClosePopupOnNavigation } from '@gem/popups';
import { Button, ButtonTypes, PopupFooter } from '@gem/ui-kit';

import { DeleteSpaceGroupsList } from './DeleteSpaceGroupsList/DeleteSpaceGroupsList';
import {
  IDeleteSpacePopupParams,
  useDeleteSpacePopupPresenter,
} from './DeleteSpacePopup.presenter';
import styles from './DeleteSpacePopup.styles.m.css';

export const DeleteSpacePopup: FC<ICommonPopupsProps<IDeleteSpacePopupParams>> = observer(
  (props) => {
    const { t } = useTranslation();
    const presenter = useDeleteSpacePopupPresenter(props);
    useClosePopupOnNavigation(props.popupInstance);

    return (
      <Popup
        className={presenter.isEmpty ? styles.popupEmptyGroups : undefined}
        title={t('space_delete_space')}
        isOpened={!!presenter.space}
        handlePrevStep={presenter.hasBackButton ? presenter.onBack : null}
        onClose={presenter.onClose}
      >
        <h6 className={styles.title}>
          {t('space_delete_community_subhint', { 0: presenter.space?.name })}
        </h6>

        {presenter.showDivider && <div className={styles.divider}></div>}

        {presenter.showGroupList && (
          <>
            <div className={styles.header}>
              <span className={styles.headerTitle}>
                {t('space_number_chat_delete', { 0: presenter.selectedGroups.size })}
              </span>

              <button
                className={styles.deselectButton}
                type="button"
                disabled={!presenter.selectedGroups.size}
                onClick={presenter.onDeselectAll}
              >
                {t('space_deselect_button')}
              </button>
            </div>

            <DeleteSpaceGroupsList
              groups={presenter.groups}
              selectedGroups={presenter.selectedGroups}
              onToggleGroup={presenter.onToggleGroup}
            />
          </>
        )}

        {presenter.isLoading && (
          <div className={styles.placeholder}>
            <GroupsPlaceholder
              className={styles.placeholderItem}
              count={10}
            />
          </div>
        )}

        <PopupFooter>
          <Button
            type={ButtonTypes.Button}
            isDisabled={presenter.isSubmitting || presenter.isLoading}
            isLoading={presenter.isSubmitting}
            onClick={presenter.onSubmit}
            theme="primary"
          >
            {t('delete')}
          </Button>
        </PopupFooter>
      </Popup>
    );
  }
);
